var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('iframe',{staticClass:"pb-10 pt-10",attrs:{"src":"https://www.ddlottery.com/result-blog","width":"100%","height":"90%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }